import { baseURL } from "../../../../../services/axios";

// Resolves the Express proxy URL for custom fonts.
// Browsers can't send custom headers for `@font-face`, so we pass JWT via `?token=`.
export const getApiFontUrl = (proxyPath) => {
  const authTokenRaw = localStorage.getItem("authToken");
  let token = "";

  if (authTokenRaw) {
    try {
      const parsed = JSON.parse(authTokenRaw);
      token = typeof parsed === "string" ? parsed : "";
    } catch (e) {
      // authToken might already be a raw string (not JSON-encoded)
      token = authTokenRaw;
    }
  }

  return `${baseURL}${proxyPath}?token=${encodeURIComponent(token)}`;
};

export const injectFontFaceFromUrl = (fontFamily, url) => {
  if (!fontFamily || !url) return;

  // Remove stale tag (e.g. expired S3 signed URL) before re-injecting.
  const existing = document.querySelector(
    `style[data-custom-font="${fontFamily}"]`,
  );
  if (existing) existing.remove();

  const style = document.createElement("style");
  style.setAttribute("data-custom-font", fontFamily);
  style.textContent = `@font-face { font-family: '${fontFamily}'; src: url('${url}'); font-weight: normal; font-style: normal; font-display: swap; }`;
  document.head.appendChild(style);
};
